__turbopack_context__.v({
  "action": "TrendsExplorer-module__XGK7eq__action",
  "actionPrimary": "TrendsExplorer-module__XGK7eq__actionPrimary",
  "bar": "TrendsExplorer-module__XGK7eq__bar",
  "barFill": "TrendsExplorer-module__XGK7eq__barFill",
  "barTrack": "TrendsExplorer-module__XGK7eq__barTrack",
  "barWrap": "TrendsExplorer-module__XGK7eq__barWrap",
  "brandCell": "TrendsExplorer-module__XGK7eq__brandCell",
  "brandName": "TrendsExplorer-module__XGK7eq__brandName",
  "chart": "TrendsExplorer-module__XGK7eq__chart",
  "chartCard": "TrendsExplorer-module__XGK7eq__chartCard",
  "chartHead": "TrendsExplorer-module__XGK7eq__chartHead",
  "chip": "TrendsExplorer-module__XGK7eq__chip",
  "chipActive": "TrendsExplorer-module__XGK7eq__chipActive",
  "console": "TrendsExplorer-module__XGK7eq__console",
  "delta": "TrendsExplorer-module__XGK7eq__delta",
  "dot": "TrendsExplorer-module__XGK7eq__dot",
  "down": "TrendsExplorer-module__XGK7eq__down",
  "flat": "TrendsExplorer-module__XGK7eq__flat",
  "gscTab": "TrendsExplorer-module__XGK7eq__gscTab",
  "gscTabActive": "TrendsExplorer-module__XGK7eq__gscTabActive",
  "gscTabs": "TrendsExplorer-module__XGK7eq__gscTabs",
  "kpi": "TrendsExplorer-module__XGK7eq__kpi",
  "kpiBlue": "TrendsExplorer-module__XGK7eq__kpiBlue",
  "kpiLabel": "TrendsExplorer-module__XGK7eq__kpiLabel",
  "kpiPurple": "TrendsExplorer-module__XGK7eq__kpiPurple",
  "kpiRow": "TrendsExplorer-module__XGK7eq__kpiRow",
  "kpiSub": "TrendsExplorer-module__XGK7eq__kpiSub",
  "kpiUp": "TrendsExplorer-module__XGK7eq__kpiUp",
  "kpiValue": "TrendsExplorer-module__XGK7eq__kpiValue",
  "legItem": "TrendsExplorer-module__XGK7eq__legItem",
  "legend": "TrendsExplorer-module__XGK7eq__legend",
  "menuWrap": "TrendsExplorer-module__XGK7eq__menuWrap",
  "meta": "TrendsExplorer-module__XGK7eq__meta",
  "moverCard": "TrendsExplorer-module__XGK7eq__moverCard",
  "moverHead": "TrendsExplorer-module__XGK7eq__moverHead",
  "moverName": "TrendsExplorer-module__XGK7eq__moverName",
  "moverPct": "TrendsExplorer-module__XGK7eq__moverPct",
  "moverRow": "TrendsExplorer-module__XGK7eq__moverRow",
  "movers": "TrendsExplorer-module__XGK7eq__movers",
  "num": "TrendsExplorer-module__XGK7eq__num",
  "pill": "TrendsExplorer-module__XGK7eq__pill",
  "pillLabel": "TrendsExplorer-module__XGK7eq__pillLabel",
  "pillSelect": "TrendsExplorer-module__XGK7eq__pillSelect",
  "r1": "TrendsExplorer-module__XGK7eq__r1",
  "r2": "TrendsExplorer-module__XGK7eq__r2",
  "r3": "TrendsExplorer-module__XGK7eq__r3",
  "rank": "TrendsExplorer-module__XGK7eq__rank",
  "rankMedal": "TrendsExplorer-module__XGK7eq__rankMedal",
  "segOn": "TrendsExplorer-module__XGK7eq__segOn",
  "segmented": "TrendsExplorer-module__XGK7eq__segmented",
  "shareMenu": "TrendsExplorer-module__XGK7eq__shareMenu",
  "spacer": "TrendsExplorer-module__XGK7eq__spacer",
  "spark": "TrendsExplorer-module__XGK7eq__spark",
  "table": "TrendsExplorer-module__XGK7eq__table",
  "tableFoot": "TrendsExplorer-module__XGK7eq__tableFoot",
  "tableWrap": "TrendsExplorer-module__XGK7eq__tableWrap",
  "tabs": "TrendsExplorer-module__XGK7eq__tabs",
  "toolbar": "TrendsExplorer-module__XGK7eq__toolbar",
  "up": "TrendsExplorer-module__XGK7eq__up",
  "vendor": "TrendsExplorer-module__XGK7eq__vendor",
});
